import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";
import {InvoiceTypePipe} from "../../pipes/invoice-type.pipe";
import {AccessService} from "../../services/access.service";
import {Right} from "../../interfaces";

@Component({
    selector: 'app-invoice-type-list',
    imports: [RouterLink, NgIf, InvoiceTypePipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-store me-2"></i>Rechnungskreise <small class="text-muted">({{entries?.length}})</small></h3>
                </div>

                @if (accessService.hasRight(Right.MANAGE_INVOICE_TYPES)) {
                    <button type="button" class="btn btn-primary mb-3" [routerLink]="['/invoicetype', 0]">Rechnungskreis anlegen</button>
                }

                <div class="table-responsive">
                    <table *ngIf="entries?.length > 0" class="table table-striped table-hover mb-0 pointer">
                        <thead>
                        <tr>
                            <th (click)="setOrder('name')">
                                Bezeichnung <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('assigned')">
                                Zugeordnet <i class="fa-solid" *ngIf="predicate == 'assigned'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('start')">
                                Startnummer <i class="fa-solid" *ngIf="predicate == 'start'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('email')">
                                E-Mail <i class="fa-solid" *ngIf="predicate == 'email'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('iban')">
                                IBAN <i class="fa-solid" *ngIf="predicate == 'iban'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('bic')">
                                BIC <i class="fa-solid" *ngIf="predicate == 'bic'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        @for (entry of entries; track entry.id) {
                            <tr [routerLink]="['/invoicetype', entry.id]">
                                <td>{{ entry.name | invoiceType }}</td>
                                <td>{{ entry.assigned }} ({{ entry.assigned_type }})</td>
                                <td>{{ entry.start }}</td>
                                <td>{{ entry.email }}</td>
                                <td>{{ entry.iban }}</td>
                                <td>{{ entry.bic }}</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})
export class InvoiceTypeListComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);

    protected readonly Right = Right;

    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'assigned';
    reverse = false;

    ngOnInit(): void {
        this.listEntries();
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.listEntries();
    }

    listEntries(): void {
        this.entries = null;
        this.dataService.request('InvoiceType/listAll', {
            order: this.predicate,
            reverse: this.reverse,
        }).subscribe(response => {
            this.entries = response.types;
        });
    }
}
